import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '~/eds/src/components/Button/Button';
import { useIntl } from 'react-intl';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';

const SavedSearchesTypesButtonGroup = ({ types, setTypesChange }) => {
  const intl = useIntl();

  const handleTypeToggle = (type) => {
    const typesToSet = types.includes(type)
      ? types.filter((item) => item !== type)
      : [...types, type];
    setTypesChange(typesToSet);
  };

  const SaveSearchesTypes = [
    {
      label: intl.formatMessage({
        id: 'SavedSearchesTypesButtonGroup.mySearches',
        defaultMessage: 'My Saved Searches',
        description: 'Label for my saved searches button',
      }),
      value: 'mySearches',
    },
    {
      label: intl.formatMessage({
        id: 'SavedSearchesTypesButtonGroup.sharedSearches',
        defaultMessage: 'Shared with me',
        description: 'Label for shared searches button',
      }),
      value: 'sharedSearches',
    },
  ];

  const getButtons = () => {
    return SaveSearchesTypes.map((type) => {
      return (
        <Button
          key={type.value}
          text={type.label}
          variant={types.includes(type.value) ? 'primary' : 'secondary'}
          onClick={() => handleTypeToggle(type.value)}
        />
      );
    });
  };

  return (
    <FlexLayout pb={8} space={3}>
      {getButtons()}
    </FlexLayout>
  );
};

SavedSearchesTypesButtonGroup.propTypes = {
  types: PropTypes.array.isRequired,
  setTypesChange: PropTypes.func.isRequired,
};

export default SavedSearchesTypesButtonGroup;
